export default __webpack_public_path__ + "static/media/logo-large.1c13c690.png";